<template>
  <div :key="show">
    <template v-for="(i,idx) in loopItem">
      <span v-if="show? true : idx < max" :key="(i&&i.value) ? `${i.value}-${idx}` : idx">
        {{ i.default }}
        {{ addCommaCount > idx ? ',':'' }}
        {{ ((needButton===true)&&(show===false)&&(idx==max-1)) ? '...':'' }}
      </span>
    </template>
    <div v-if="loopItem.length > max" class="text-right">
      <div @click="showAll" class="showAllButton">
        {{ show ? '-' : '+' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      default: null,
      type: [Array, Object]
    }
  },
  data: function () {
    return {
      max: 5,
      show: false,
      needButton: false,
      loopItem: [],
      addCommaCount: 0
    }
  },
  mounted() {
    this.loopItem = Object.values(this.item)
    this.needButton = this.loopItem.length > this.max
    this.updateCount()
  },
  methods: {
    showAll() {
      this.show = !this.show
      this.updateCount()
    },
    updateCount() {
      const addComma = this.show === true || (this.loopItem.length < this.max) === true
      this.addCommaCount = addComma ? this.loopItem.length - 1 : this.max - 1
    }
  }
}

</script>
<style>
  .showAllButton {
    cursor: pointer;
    display: inline-block;
    color: white;
    background: #003979;
    width: 24px;
    text-align: center;
    height: 18px;
    border-radius: 40%;
    line-height: 18px;
    font-size: 18px;
  }

</style>
